import { z } from "zod"

export const PowurOSAccessLevel = z.enum([`read`, `edit`, `none`])

export type PowurOSAccessLevel = z.infer<typeof PowurOSAccessLevel>

export const powurOsResponseSchema = z.object({
  success: z.boolean(),
  errors: z.any(),
  error: z.any(),
  access: z.object({
    fields: z.record(PowurOSAccessLevel),
  }),
  page: z.number().optional(),
  records: z.number().optional(),
  recordsPerPage: z.number().optional(),
})

export type PowurOsResponse = z.infer<typeof powurOsResponseSchema>
